module.exports = __webpack_public_path__ + "img/bnr_quest-s.c8503eb3.png";